export default __webpack_public_path__ + "static/media/thirdMobile.420e46bf.svg";